import { render, staticRenderFns } from "./ConfigAlertFailMessage.vue?vue&type=template&id=65784854&scoped=true"
import script from "./ConfigAlertFailMessage.vue?vue&type=script&lang=js"
export * from "./ConfigAlertFailMessage.vue?vue&type=script&lang=js"
import style0 from "./ConfigAlertFailMessage.vue?vue&type=style&index=0&id=65784854&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65784854",
  null
  
)

export default component.exports